<template>
  <div>
    <div v-if="cap === 'owner' || cap === 'superadmin'" class="askeval">
      <h3>評価リクエスト</h3>
      <ul>
        <li>
          <button
            @click="toggleAskEval('periodical')"
            :class="{ active: parseInt(clientData.options.askeval.periodical) > 0 }"
          >人事</button></li>
        <li>
          <button
            @click="toggleAskEval('bonus')"
            :class="{ active: parseInt(clientData.options.askeval.bonus) > 0 }"
          >賞与</button></li>
      </ul>
      <div class="status">
        <span v-if="parseInt(clientData.options.askeval.periodical) > 0">定期評価リクエスト中</span>
        <span v-if="parseInt(clientData.options.askeval.bonus) > 0">賞与評価リクエスト中</span>
      </div>
    </div>

    <div v-if="cap === 'owner' || cap === 'superadmin'" class="paybonus" @click="payBonus">
      <span><i class="fa-solid fa-sack-dollar"></i>賞与支給</span>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      cap: localStorage.getItem('capability'),
      clientData: this.$store.getters['Client/clientData']
    }
  },
  mounted () {
    console.log(this.$route.name)
    this.$store.watch(
      (state, getters) => getters['Auth/capability'],
      (newValue) => {
        this.cap = newValue
      }
    )
    this.$store.watch(
      (state, getters) => getters['Client/clientData'],
      (newValue) => {
        this.clientData = newValue
      }
    )
  },
  methods: {
    toggleAskEval (cat) {
      this.$store.commit('Modal/mode', cat)
      switch (cat) {
        case 'periodical':
          if (parseInt(this.clientData.options.askeval.periodical) > 0) {
            // inactivate periodical eval
            this.canselEval('定期評価')
          } else {
            // activate periodical eval
            this.requestEval('定期評価')
          }
          break
        case 'bonus':
          if (parseInt(this.clientData.options.askeval.bonus) > 0) {
            // inactivate bonus
            this.canselEval('賞与評価')
          } else {
            // activate bonus
            this.requestEval('賞与評価')
          }
          break
      }
    },
    //
    // 評価リクエスト
    requestEval (str) {
      if (confirm(`${str}をリクエストします。\n実行しますか？`)) {
        this.$store.commit('Modal/show', true)
        this.$store.commit('Modal/content', 'set evaluation range')
      }
    },
    //
    // 評価リクエストキャンセル
    canselEval (str) {
      if (confirm(`${str}リクエストをキャンセルしますか？`)) {
        this.$store.dispatch('Eval/evalDeactivate')
        this.clientData.options.askeval.periodical = '0'
      }
    },
    requestSelfCheck () {
      if (confirm('評価提出をリクエストします。\n実行しますか？')) {
        // this.$store.dispatch('SelfExam/activate')
        // this.clientData.options.selfcheck = '1'
        this.$store.commit('Modal/show', true)
        this.$store.commit('Modal/content', 'set evaluation range')
      }
    },
    canselSelfCheck () {
      if (confirm('評価提出リクエストをキャンセルしますか？')) {
        this.$store.dispatch('Eval/evalDeactivate', 'periodical')
        this.clientData.options.askeval.periodical = '0'
      }
    },
    requestEvalBonus () {
      if (confirm('賞与評価提出をリクエストします。\n実行しますか？')) {
        // this.$store.dispatch('SelfExam/activate')
        // this.clientData.options.selfcheck = '1'
        this.$store.dispatch('Eval/evalRequest', 'bonus')
      }
    },
    canselEvalBonus () {
      if (confirm('賞与評価提出リクエストをキャンセルしますか？')) {
        this.$store.dispatch('Eval/evalDeactivate', 'bonus')
        this.clientData.options.askeval.bonus = '0'
      }
    },
    payBonus () {
      console.log('payBonus')
      this.$router.push({ name: 'PayBonus' })
    }
  }
}
</script>

<style scoped>
@media (min-width: 1700px) {
  .selfchk .status {
    padding: 30px 20px;
  }
  .selfchk .action span {
    padding: 10px;
  }
  .paybonus {
    padding: 30px 10px;
  }
}
@media (max-width: 1699px) {
  .selfchk .status {
    font-size: 12px;
    padding: 20px 5px;
  }
  .selfchk .action span {
    font-size: 12px;
    padding: 5px;
  }
  .paybonus {
    font-size: 14px;
    padding: 20px 5px;
  }
}
.selfchk {
  padding: 10px;
  background-color: #fff;
  border: 1px solid var(--border-color);
  margin-bottom: 20px;
}
.selfchk h3 {
  font-weight: bold;
  color: var(--theme-color);
  margin-bottom: 10px;
}
.selfchk .status {
  text-align: center;
  background-color: #dfe6ff;
  margin-bottom: 10px;
  font-weight: bold;
  line-height: 1.1;
}
.selfchk .action span {
  display: block;
  text-align: center;
  background-color: var(--thead-color);
  color: #fff;
  font-weight: bold;
}
.selfchk .action span:hover {
  cursor: pointer;
}
.paybonus {
  background-color: #fff;
  border: 1px solid var(--border-color);
  background-color: #dfe6ff;
  margin-bottom: 20px;
  font-weight: bold;
  color: var(--theme-color);
  text-align: center;
  box-shadow: 3px 3px 0 rgba(0,0,0,0.5);
}
.paybonus:hover {
  cursor: pointer;
}
</style>
